import React from 'react'
import styled from "styled-components"
import useSiteMetadata from '../hooks/use-site-config'
import useSiteImages from '../hooks/use-site-images'
import Image from "gatsby-image"
const FooterText = styled(Image)`

margin:auto;
width: 40%;
@media only screen and (max-width:500px){
  width:100%;
}
`

const FooterContainer = styled.footer`
position: absolute;
bottom: 0;
height: 90px;    
padding: 20px 0;
background: linear-gradient( 90deg, rgba(239, 130, 0, 1) 10%, rgba(228, 0, 169, 1) 50%, rgba(80, 35, 94, 1) 90% ) !important;
margin-top: 2rem;

  display: table;
  width: 100%;
  overflow: hidden;
 
` 


const Footer = ({ props, className }) => {
  const footerT = useSiteImages('footer_text').fluid
  
  return (
    <FooterContainer  className={className}>
      <FooterText loading="eager" fluid={footerT} />
      <span className="version" >v1.0.2</span>
    </FooterContainer>
  )
}

export default Footer
